import { SparklesIcon } from './icons/Icon.js';

export const DemoRibbon = () => (
  <div className="flex items-center justify-center gap-2 bg-accent/15 px-4 py-1.5 text-[11px] font-medium text-accent border-b border-accent/20">
    <SparklesIcon size={14} />
    <span>Public demo — your changes stay on this device.</span>
  </div>
);
